export default {
  activityType: {
    RESTAURANT: "Restaurante",
    ATTRACTION: "Atracción",
    GENERIC_SERVICE: "Servicio",
  },
  cuisine: {
    italian: "Italiana",
    spanish: "Española",
    canarian: "Canaria",
    mediterranean: "Mediterránea",
    japanese: "Japonesa",
    chinese: "China",
    thai: "Tailandesa",
    indian: "India",
    mexican: "Mexicana",
    american: "Americana",
    french: "Francesa",
    greek: "Griega",
    middle_eastern: "Oriente Medio",
    seafood: "Mariscos",
    steakhouse: "Steakhouse",
    vegetarian: "Vegetariana/Vegana",
    pizza: "Pizza",
    sushi: "Sushi",
    ramen: "Ramen",
    tapas: "Tapas",
    fast_food: "Comida rápida",
    cafe: "Cafetería/Bistró",
    fusion: "Fusión",
    international: "Internacional",
    other: "Otra",
  },
  menuCategory: {
    APPETIZER: "Entrante",
    FIRST_COURSE: "Primer plato",
    SECOND_COURSE: "Segundo plato",
    SIDE_DISH: "Guarnición",
    SALAD: "Ensalada",
    PIZZA: "Pizza",
    SOUP: "Sopa",
    DESSERT: "Postre",
    FRUIT: "Fruta",
    CHEESE: "Queso",
    BEVERAGE: "Bebida",
    WINE: "Vino",
    COCKTAIL: "Cóctel",
    COFFEE: "Café",
    KIDS_MENU: "Menú infantil",
    SPECIAL: "Especial",
  },
  lang: {
    en: "Inglés",
    it: "Italiano",
    es: "Español",
    de: "Alemán",
  },
} as const;
